(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/tabs-resize/assets/javascripts/tabs-plugin.js') >= 0) return;  svs.modules.push('/components/components/tabs-resize/assets/javascripts/tabs-plugin.js'); 
var svs = svs || {};


svs.components = svs.components || {};

svs.components.tabPlugins = svs.components.tabPlugins || {};

svs.components.tabPlugins.resize = function(options) {
  var self = this,
    maxHeight,
    swiper;

  function init() {
    swiper = new svs.components.Swiper();

    if (!options.noAutoResizeSlides) {
      self.on('change', function(slide) {
        resizeTabs(self.contentSlider.getSlides(), slide.tab);
      });

      self.on('resize', function(tab) {
        resizeTabs(self.contentSlider.getSlides(), tab);
      });

      self.on('destroy', function() {
        if (swiper) {
          swiper.dispose();
          swiper = null;
        }

        $(window.document).off('resizeTabView');
      });
    }

    self.setMaxHeight = setMaxHeight;

    $(window.document).on('resizeTabView', function() {
      self.resize();
    });

    $(window).on('resize', function() {
      self.resize();
    });
  }

  function setMaxHeight(height) {
    maxHeight = height;
  }

  function getVisibleArea(options, slides) {
    var tabEl = $(options.el),
      navItemsEl = $(options.navItemsEl),
      firstSlide = slides.first(),
      header = $('.header'),
      headerHeight = header.length > 0 ? header.outerHeight() : 0,
      betslip = $('#betslip-footer'),
      betslipRealHeight =
        betslip.length > 0 && betslip.is(':visible') ? betslip.height() : 0,
      betslipHeight = svs.core.detect.formfactor.mobile()
        ? betslipRealHeight
        : 0;

    if (options.useSplitTab) {
      return firstSlide.length > 0
        ? $(window).innerHeight() -
            (firstSlide.offset().top - navItemsEl
              ? navItemsEl.offset().top
              : 0) -
            betslipHeight -
            headerHeight
        : $(window).innerHeight();
    }
    return firstSlide.length > 0
        ? $(window).innerHeight() -
            (firstSlide.offset().top - tabEl.offset().top) -
            betslipHeight -
            headerHeight
        : $(window).innerHeight();

  }

  function getMaxHeight(options) {
    var tabEl, tabTabsEl;
    if (options.useSplitTab) {
      tabEl = $(options.navContentEl);
      tabTabsEl = tabEl.find('.js-tabs-tabs');
      return maxHeight ? maxHeight - tabTabsEl.height() : null;
    }
    tabEl = $(options.el);
    tabTabsEl = tabEl.find('.js-tabs-tabs');
    return maxHeight ? maxHeight - tabTabsEl.height() : null;

  }

  function resizeTabs(slides, tab) {
    var tabEl = $(options.el),
      tabTabsEl = tabEl.find('.js-tabs-tabs'),
      actionBar = $('#actionbar-content'),
      isActionBarVisible = actionBar.is(':visible'),
      betslip = $('#betslip-footer'),
      firstSlide = slides.first(),
      isInModal = firstSlide.parents('.js-modal-container').length > 0,
      visibleArea = getVisibleArea(options, slides),
      currentMaxHeight = getMaxHeight(options),
      swiperOptions = {
        scrollbars: false,
        scrollingX: false,
        scrollingY: true
      };

    if (options.excludeActionBarHeight && svs.core.detect.formfactor.mobile()) {
      visibleArea -= isActionBarVisible ? actionBar.outerHeight(true) : 0;
      visibleArea += betslip.is(':visible') && isActionBarVisible ? 5 : 0; 
    }

    if (options.excludeHeight) {
      visibleArea -= options.excludeHeight;
    }

    slides.each(function() {
      var $this = $(this);
      $this.css('min-height', '0px');
      $this.children('.slide-inverted').css('min-height', '0px');
    });

    slides.each(function() {
      var $this = $(this),
        offsetTop = Math.ceil($this.offset().top),
        windowHeight = $(window).height(),
        minHeight =
          $this.outerHeight() > visibleArea ? $this.outerHeight() : visibleArea,
        height = windowHeight - offsetTop;

      if (isInModal) {
        if (svs.core.detect.formfactor.mobile()) {
          height =
            $this.parents('.modal-content').height() -
            $('.modal-header').outerHeight() -
            tabTabsEl.height();
        } else {
          if (currentMaxHeight) {
            if ($this.outerHeight() < currentMaxHeight) {
              height = 'auto';
            } else {
              height = currentMaxHeight;
            }
          } else {
            height = 'auto';
          }
        }
      }

      if (!options.doNotSetHeight) {
        $this.css('height', height);
      }
      minHeight = height;

      var useSwiper = true;

      if (typeof tab.useSwiper === 'boolean' && tab.useSwiper === false) {
        useSwiper = false;
      }

      if (useSwiper && $this.hasClass('slider-slide-active')) {
        swiper.init($this, swiperOptions);
      } else {
        $this
          .find('.js-swiper-container:not(.tab-resize-dont-remove)')
          .children(':first')
          .unwrap();
      }
      $this.css('min-height', minHeight);

      $this.children('.slide-inverted').css('min-height', minHeight);
    });

    setTimeout(function() {
      self.trigger('sizeUpdated');
    }, 10);
  }

  init();
};

 })(window);